export const Breakpoints = {
  desktop: 1280,
  laptop: 1024,
  tablet: 768,
  mobile: 480
};